import { WebStorageStateStore } from 'oidc-client-ts';

import type { RuntimeConfig } from '@/config';

import type { AuthProviderProps } from 'react-oidc-context';

export function createOidcConfig(config: RuntimeConfig): AuthProviderProps {
  return {
    authority: config.authAuthority,
    client_id: config.authClientId,
    ...(config.authClientSecret
      ? { client_secret: config.authClientSecret }
      : {}),
    scope: 'openid profile',
    redirect_uri: window.location.origin + window.location.pathname,
    post_logout_redirect_uri: window.location.origin,
    staleStateAgeInSeconds: 3600,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    onSigninCallback: () => {
      window.history.replaceState({}, '', window.location.pathname);
    },
  };
}
